export type PermissionAction = 'view' | 'add' | 'edit' | 'delete' | 'export' | 'import';
export type PermissionFlag = 'isView' | 'isAdd' | 'isEdit' | 'isDelete' | 'isExport' | 'isImport';

export const PERMISSION_FLAG: Record<PermissionAction, PermissionFlag> = {
  view: 'isView',
  add: 'isAdd',
  edit: 'isEdit',
  delete: 'isDelete',
  export: 'isExport',
  import: 'isImport',
};

/** Order and labels of the role permission matrix columns. */
export const PERMISSION_COLUMNS: { flag: PermissionFlag; label: string }[] = [
  { flag: 'isView', label: 'View' },
  { flag: 'isAdd', label: 'Add' },
  { flag: 'isEdit', label: 'Edit' },
  { flag: 'isDelete', label: 'Delete' },
  { flag: 'isExport', label: 'Export' },
  { flag: 'isImport', label: 'Import' },
];

/** Flags that require View to be granted first. */
export const NON_VIEW_FLAGS: PermissionFlag[] = ['isAdd', 'isEdit', 'isDelete', 'isExport', 'isImport'];

export interface MenuPermission {
  menuId: number;
  menuKey: string;
  menuName: string;
  parentMenuId: number | null;
  parentMenuKey: string | null;
  isParent: boolean;
  isView: boolean;
  isAdd: boolean;
  isEdit: boolean;
  isDelete: boolean;
  isExport: boolean;
  isImport: boolean;
}

/** Role id of the Super Admin role (API: Constants.SuperAdminRoleId). Only a Super Admin may modify or assign it. */
export const SUPER_ADMIN_ROLE_ID = 1;

/** Role and effective permissions of the signed-in admin, sent once in the login response. */
export interface MyPermissions {
  roleId: number;
  roleName: string;
  menus: MenuPermission[];
}

export interface RoutePermissionData {
  menuKey?: string;
  action?: PermissionAction;
  skipPermission?: boolean;
  /** On denial, redirect to the role's first allowed page instead of /not-authorized. */
  fallbackToFirstAllowed?: boolean;
}

/** Code sent by the API when the role lacks a menu/action permission (distinct from a CSRF/session 403). */
export const PERMISSION_DENIED_CODE = 'PERMISSION_DENIED';

export function isPermissionDenied(error: any): boolean {
  return error?.status === 403 && error?.error?.code === PERMISSION_DENIED_CODE;
}
